import { searchGame } from '@/services/community/wikigamer/games/games'
import {
	deleteNewsletter,
	newsletterByID,
	newsletterCreate,
	newsletters,
	newsletterUpdate,
	newsletterDuplicates,
	newsletterBulkDelete,
} from '@/services/newsletters.service'

export default {
	namespaced: true,
	state: {
		// NEWSLETTER
		newsletters: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		newsletter: {},
		newslettersStatus: 'init',
		newslettersSaveStatus: 'init',
		deleteNewsletterStatus: 'init',
		duplicates: [],
		duplicatesStatus: 'init',
		bulkDeleteStatus: 'init',
	},
	getters: {
		// NEWSLETTER
		newsletters(state) {
			return state.newsletters
		},
		getNewsletter(state) {
			return state.newsletter
		},
		newslettersStatus(state) {
			return state.newslettersStatus
		},
		getNewslettersSaveStatus(state) {
			return state.newslettersSaveStatus
		},
		deleteNewsletterStatus(state) {
			return state.deleteNewsletterStatus
		},
		duplicates(state) {
			return state.duplicates
		},
		duplicatesStatus(state) {
			return state.duplicatesStatus
		},
		bulkDeleteStatus(state) {
			return state.bulkDeleteStatus
		},
	},
	mutations: {
		// NEWSLETTERS
		SET_NEWSLETTERS(state, val) {
			state.newsletters = val
		},
		SET_NEWSLETTER(state, value) {
			state.newsletter = value
		},
		SET_NEWSLETTERS_STATUS(state, val) {
			state.newslettersStatus = val
		},
		SET_DELETE_NEWSLETTER_STATUS(state, val) {
			state.deleteMessageStatus = val
		},
		NEWSLETTER_SAVE_STATUS(state, value) {
			state.newslettersSaveStatus = value
		},
		SET_DUPLICATES(state, val) {
			state.duplicates = val
		},
		SET_DUPLICATES_STATUS(state, val) {
			state.duplicatesStatus = val
		},
		SET_BULK_DELETE_STATUS(state, val) {
			state.bulkDeleteStatus = val
		},
	},
	actions: {
		// NEWSLETTERS
		async fetchNewsletters({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SET_NEWSLETTERS_STATUS', 'pending')
			commit('SET_NEWSLETTERS', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await newsletters(params)
				console.log(data)
				commit('SET_NEWSLETTERS_STATUS', 'init')
				commit('SET_NEWSLETTERS', data)
				return data
			} catch (error) {
				commit('SET_NEWSLETTERS_STATUS', 'init')
				throw error
			}
		},
		async fetchNewsletterByID({ commit }, params) {
			commit('NEWSLETTERS_STATUS', 'pending')
			try {
				const { data } = await newsletterByID(params)
				commit('NEWSLETTERS_STATUS', 'init')
				commit('SET_NEWSLETTER', data.data)
				return data
			} catch (error) {
				commit('NEWSLETTERS_STATUS', 'init')

				return error
			}
		},
		async saveNewNewsletter({ commit }, params) {
			commit('NEWSLETTER_SAVE_STATUS', 'pending')
			try {
				const { data } = await newsletterCreate(params)
				commit('NEWSLETTER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('NEWSLETTER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateNewsletter({ commit }, params) {
			commit('NEWSLETTER_SAVE_STATUS', 'pending')
			try {
				const { data } = await newsletterUpdate(params)
				commit('NEWSLETTER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('NEWSLETTER_SAVE_STATUS', 'init')
				throw error
			}
		},

		async fetchDuplicates({ commit }, params) {
			commit('SET_DUPLICATES_STATUS', 'pending')
			try {
				const { data } = await newsletterDuplicates(params)
				commit('SET_DUPLICATES_STATUS', 'init')
				commit('SET_DUPLICATES', data.data)
				return data.data
			} catch (error) {
				commit('SET_DUPLICATES_STATUS', 'init')
				throw error
			}
		},

		async bulkDeleteNewsletters({ commit }, ids) {
			commit('SET_BULK_DELETE_STATUS', 'pending')
			try {
				const { data } = await newsletterBulkDelete(ids)
				commit('SET_BULK_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_BULK_DELETE_STATUS', 'init')
				throw error
			}
		},

		async deleteNewsletterByID({ commit }, params) {
			commit('SET_DELETE_NEWSLETTER_STATUS', 'pending')
			try {
				const { data } = await deleteNewsletter(params)
				commit('SET_DELETE_NEWSLETTER_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_DELETE_NEWSLETTER_STATUS', 'init')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				throw error
			}
		},
	},
}
